import './style.scss';
import { trackClick } from '../util/util'
import { designs } from './designs'

export const SrpAds = ({index, phoneNumber, position }) => {
    const content = designs[index];
    let mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    return (
        <div className={`srp-list-item srp-ads ads${index}`}>
            <div className="srp-list-subcontainer">
                <div className="group1">
                    <div className="text1">{content.text1}</div>
                    <div className="text2">{content.text2}</div>
                </div>
                <div className="group2">
                    <div className="text3">{content.text3}</div>
                    <div className="text4">{content.text4}</div>
                </div>
                <div className="cta">
                    <a
                        href={mobile ? "tel://" + phoneNumber : "#"}
                        onClick={(e) => {
                            trackClick("srp_realtor_clicktocall", `position:${position}, creative:${content.creative}`);
                            console.log("GA event tracked: ","srp_realtor_clicktocall", `position:${position}, creative:${content.creative}`);
                        }}
                    >
                        {mobile ? content.button : phoneNumber}
                    </a>
                    {/* <span class="tooltiptext">{phoneNumber}</span> */}
                </div>
            </div>
        </div>
    );
}